import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';

import { parseDateTime } from '../../../../common/date-time';

const ReseLeakDetectionMonitoringInfoDialog = ({ dialogData, setDialogData }) => {

    // Cache the last non-null dialogData so the dialog content stays stable
    // while the close animation plays out, instead of flashing to NA/undefined
    // the instant the dialog starts hiding.
    const [cachedData, setCachedData] = useState(dialogData);

    useEffect(() => {
        if (dialogData) {
            setCachedData(dialogData);
        }
    }, [dialogData]);

    const createdAt = !!cachedData && cachedData.createdTimestamp ? parseDateTime(cachedData.createdTimestamp) : "NA";
    const modifiedBy = !!cachedData && cachedData.modifiedBy ? cachedData.modifiedBy : "NA";
    const modifiedAt = !!cachedData && cachedData.modifiedTimestamp ? parseDateTime(cachedData.modifiedTimestamp) : "NA";

    return (
        <div>
            <Dialog
                visible={!!dialogData}
                onHide={() => setDialogData(null)}
                header={`Store ID: ${cachedData?.storeId}`}
                style={{ width: "50vw" }}
            >
                <div>
                    <p>
                        <span style={{ fontWeight: 700 }}>Notes : </span>
                        {cachedData?.notes || "NA"}
                    </p>
                    <Divider />
                    <p>
                        <span style={{ fontWeight: 700 }}>Created By : </span>
                        {cachedData?.createdBy}
                    </p>
                    <Divider />
                    <p>
                        <span style={{ fontWeight: 700 }}>Created At : </span>
                        {createdAt}
                    </p>
                    <Divider />
                    <p>
                        <span style={{ fontWeight: 700 }}>Modified By : </span>
                        {modifiedBy}
                    </p>
                    <Divider />
                    <p>
                        <span style={{ fontWeight: 700 }}>Modified At : </span>
                        {modifiedAt}
                    </p>
                    <Divider />
                </div>
            </Dialog>
        </div>
    );
}

export default ReseLeakDetectionMonitoringInfoDialog;
